import type { CSSProperties } from 'react';

export const Z_INDEX = {
  portaledDropdown: 9999,
  modal: 10000,
  toast: 10050,
} as const;

export function zStyle(z: number): CSSProperties {
  return { zIndex: z };
}
